<script setup>
import { onMounted, ref } from 'vue'
import { ApiService } from '@/js/services/api'

const loading = ref(false)
const books = ref([])

const dateFormat = (date) => {
  const d = new Date(date)

  return new Intl.DateTimeFormat('ro-RO', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC',
  }).format(d)
}

const getBooks = async () => {
  loading.value = true

  books.value = await ApiService.getReservations()
  loading.value = false
}

const deleteReservation = async (reservation, event) => {
  const btn = event.target
  btn.classList.add('is-loading')

  const result = await ApiService.deleteReservation(reservation.id)
  btn.classList.remove('is-loading')

  getBooks()
}

onMounted(() => {
  getBooks()
})
</script>

<template>
  <div>
    <h1 class="is-size-3 mb-6">
      Rezervările mele

      <sup
        class="is-size-7 has-text-primary"
        v-if="books.active?.length"
        v-text="books.active.length"
      />
    </h1>

    <b-table
      :data="books.active"
      :paginated="books.active?.length > 5"
      :per-page="5"
    >
      <template #empty>Nu există cărți în această secțiune</template>

      <b-table-column
        label="#"
        width="70"
        centered
        v-slot="props"
        cell-class="has-text-grey"
      >
        {{ props.index + 1 }}
      </b-table-column>

      <b-table-column field="titlu" label="Titlu" sortable v-slot="props">
        <div>
          <p class="is-size-6 has-text-weight-semibold">
            {{ props.row.titlu }}
          </p>
          <p class="is-size-7 has-text-grey">de {{ props.row.autori_str }}</p>
        </div>
      </b-table-column>

      <b-table-column
        field="data_adaugare"
        label="Data rezervare"
        v-slot="props"
      >
        {{ dateFormat(props.row.data_adaugare) }}
      </b-table-column>

      <b-table-column
        label="Status"
        v-slot="props"
        cell-class="has-text-weight-medium is-size-7"
      >
        <p class="has-text-primary" v-if="props.row.data_limita_returnare">
          Termen de returnare <br />
          {{ dateFormat(props.row.data_limita_returnare) }}
        </p>
        <p class="has-text-primary" v-else-if="props.row.data_limita_ridicare">
          De ridicat până la
          {{ dateFormat(props.row.data_limita_ridicare) }}
        </p>
      </b-table-column>

      <b-table-column
        custom-key="actions"
        label=""
        v-slot="props"
        cell-class="has-text-right"
      >
        <b-button
          type="is-danger"
          @click="deleteReservation(props.row, $event)"
          v-if="!props.row.data_predare"
        >
          Anulează
        </b-button>
      </b-table-column>
    </b-table>

    <h1 class="is-size-3 mb-6 mt-9">
      Istoric

      <sup
        class="is-size-7 has-text-primary"
        v-if="books.istoric?.length"
        v-text="books.istoric.length"
      />
    </h1>

    <b-table
      :data="books.istoric"
      :paginated="books.istoric?.length > 5"
      :per-page="5"
    >
      <template #empty>Nu există cărți în această secțiune</template>

      <b-table-column
        label="#"
        width="70"
        centered
        v-slot="props"
        cell-class="has-text-grey"
      >
        {{ props.index + 1 }}
      </b-table-column>

      <b-table-column field="titlu" label="Titlu" sortable v-slot="props">
        <div>
          <p class="is-size-6 has-text-weight-semibold">
            {{ props.row.titlu }}
          </p>
          <p class="is-size-7 has-text-grey">de {{ props.row.autori_str }}</p>
        </div>
      </b-table-column>

      <b-table-column
        field="data_adaugare"
        label="Data rezervare"
        v-slot="props"
      >
        {{ dateFormat(props.row.data_adaugare) }}
      </b-table-column>

      <b-table-column
        field="perioada_imprumut"
        label="Perioada împrumut"
        v-slot="props"
      >
        {{ props.row.perioada_imprumut }}
      </b-table-column>

      <b-table-column
        field="data_returnare"
        label="Dată returnare"
        v-slot="props"
      >
        {{ dateFormat(props.row.data_returnare) }}
      </b-table-column>
    </b-table>
  </div>
</template>
